<template>
<nav class="l-column-nav_db">
  <div v-on:click="toggleList(mainNavi)" v-bind:class="mainNavi.show ? 'ac_ttl ac-pa open' : 'ac_ttl ac-pa'"><i class="icon-search"></i>機種一覧から探す</div>
    <transition>
      <div id="accordion" v-if="mainNavi.show">
        <div v-for="category in sortCategories" v-bind:key="category.id">
          <dl class="ac">
            <dt v-on:click="toggleListInMainNavi(category, sortCategories)" v-bind:class="category.show ? 'ac-pa open' : 'ac-pa'">
              {{category.name}}
            </dt>
            <dd class="ac-kid">
            <transition>
            <div v-if="category.show">
              <div v-for="child in category.child" v-bind:key="child.id">
                <dl>
                  <div v-if="child.child.length > 0">
                    <dt v-bind:class="child.show ? 'ac-kid-item open' : 'ac-kid-item'" v-on:click="toggleListInMainNavi(child, category.child)">
                      {{child.name}}
                    </dt>
                  </div>
                  <div v-else>
                    <dt class="ac-kid-item_kid">
                      <router-link style="text-decoration:none; display:block;" :to="{ name:'list', params:{Id: child.id}}">
                        {{child.name}}
                      </router-link>
                    </dt>
                  </div>
                  <transition>
									<div v-if="child.show">
                  <div v-for="childone in child.child" v-bind:key="childone.id">
                    <dd v-bind:class="child.show? 'ac-kid-item_kid open': 'ac-kid-item_kid'">
                      <router-link style="text-decoration: none; display:block;" :to="{ name: 'list', params: {Id: childone.id}}">
                       {{childone.name}}
                      </router-link>
                    </dd>
                  </div>
                  </div>
                  </transition>
                </dl>
              </div>
            </div>
            </transition>
            </dd>
          </dl>
        </div>
      </div>
    </transition>
  <!--
  <a class="side_menu mt-2" v-on:click="toggleList(docsNavi)" v-bind:aria-expanded="docsNavi.show"><i class="icon-books"></i>参考資料</a>
  <transition>
      <div id="side_docs" v-show="docsNavi.show">
        <a href="/../document/general-conditions/index.html">レンタル約款</a>
        <a href="/../document/rental-support/index.html">レンタル物件サポート特約制度</a>
        <a href="/../document/special-contract/index.html">レンタル保障制度</a>
        <a href="/../document/law/index.html">法規</a>
        <a href="/../document/qualification/index.html">資格</a>
        <a href="/../document/unit/index.html">単位</a>
        <a href="/../document/guide/index.html">ご利用ガイド</a>
      </div>
    </transition>
    -->
</nav>
</template>

<script> 
  export default {
    data: function () {
      return {
        specialNavi: {
          show: false
        },
        mainNavi: {
          show: false
        },
        docsNavi: {
          show: false
        },
        sortCategories: [] //categories
      }
    },
    props: {
      categorySet: {
        type: Array,
        require: true
      }
    },
    mounted () {
      this.sortCategories = this.categorySet
    },
    methods: {
      toggleList: function (menu){
        menu.show = !menu.show
      },
      toggleListInMainNavi: function (menu, uppermenus = []){
        for(var i=0;i<uppermenus.length;i++){
          uppermenus[i].show = false
        }
        this.mainNavi.show = false;
        menu.show = !menu.show;
        this.$nextTick(()=>{
          this.mainNavi.show = true;
        })
      },
    },
    watch: {
      categorySet(newSet){
        this.sortCategories = newSet
      }
    }
  }
</script>
